import React, { useState } from 'react';
import { useSearchkit } from '@searchkit/client';
import { FormCheckbox, FormikWrapper, FormSelect, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { fridayStartDate, fridayEndDate, saturdayStartDate, saturdayEndDate, SCREEN_NORMAL } from '../../../../config/constants';

import './style.scss';


const Filters = ({ initialValues, setFiltersVisible, filtersVisible }) => {

  const api = useSearchkit();
  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_NORMAL;

  const [appliedMobileFilters, setAppliedMobileFilters] = useState(initialValues);

  const getInitialFilterCount = () => {
    let count = 0;

    Object.keys(initialValues).forEach(key => {
      const value = initialValues[key];
      switch (key) {
        case 'type':
        case 'date':
        case 'availability':
          if (value !== '' && parseInt(value) !== 0) {
            count++;
          }
          break;
      }
    });

    return count;
  }

  const [selectedFilterCount, setSelectedFilterCount] = useState(getInitialFilterCount());

  const filterType = (value, autoSubmit = true) => {
    if (isMobile && autoSubmit) {
      setAppliedMobileFilters({
        ...appliedMobileFilters,
        type: value,
      });
      return;
    }

    api.removeFiltersByIdentifier('type');
    if (value !== '' && parseInt(value) !== 0) {
      api.addFilter({
        identifier: 'type',
        value: value,
      });
    }

    if (autoSubmit) {
      api.setPage({ from: 0 });
      api.search();
      setFiltersVisible(false);
    }
  };

  const filterDate = (date, autoSubmit = true) => {
    if (isMobile && autoSubmit) {
      setAppliedMobileFilters({
        ...appliedMobileFilters,
        date,
      });
      return;
    }

    const dates = [
      [fridayStartDate, fridayEndDate],
      [saturdayStartDate, saturdayEndDate],
    ];

    api.removeFiltersByIdentifier('date');
    if (date !== '' && parseInt(date) !== 0) {
      api.addFilter({
        identifier: 'date',
        min: parseInt(dates[parseInt(date) - 1][0]),
        max: parseInt(dates[parseInt(date) - 1][1]),
      });
    }

    if (autoSubmit) {
      api.setPage({ from: 0 });
      api.search();
      setFiltersVisible(false);
    }
  };

  const filterMinimumAvailability = (value, autoSubmit = true) => {
    if (isMobile && autoSubmit) {
      setAppliedMobileFilters({
        ...appliedMobileFilters,
        availability: value,
      });
      return;
    }

    api.removeFiltersByIdentifier('availability');
    if (value !== '' && parseInt(value) !== 0) {
      api.addFilter({
        identifier: 'availability',
        min: parseInt(value),
      });
    }

    if (autoSubmit) {
      api.setPage({ from: 0 });
      api.search();
      setFiltersVisible(false);
    }

  };

  const toggleFullActivities = (value, autoSubmit = true) => {
    if (isMobile && autoSubmit) {
      setAppliedMobileFilters({
        ...appliedMobileFilters,
        full: value,
      });
      return;
    }

    api.removeFiltersByIdentifier('full');
    if (!value) {
      api.addFilter({
        identifier: 'full',
        boolValue: false,
      });
    }

    if (autoSubmit) {
      api.setPage({ from: 0 });
      api.search();
      setFiltersVisible(false);
    }
  };

  const toggleHighschoolAvailability = (value, autoSubmit = true) => {
    if (isMobile && autoSubmit) {
      setAppliedMobileFilters({
        ...appliedMobileFilters,
        highschool_availability: value,
      });
      return;
    }

    api.removeFiltersByIdentifier('highschool_availability');
    if (value) {
      api.addFilter({
        identifier: 'highschool_availability',
        boolValue: true,
      });
    }

    if (autoSubmit) {
      api.setPage({ from: 0 });
      api.search();
      setFiltersVisible(false);
    }
  };

  const toggleFilters = () => {
    setFiltersVisible(!filtersVisible);
  };

  const mobileFormSubmit = () => {
    let count = 0;
    Object.keys(appliedMobileFilters).forEach(key => {
      const value = appliedMobileFilters[key];
      switch (key) {
        case 'type':
          filterType(value, false);
          if (value !== '' && parseInt(value) !== 0) {
            count++;
          }
          break;
        case 'date':
          filterDate(value, false);
          if (value !== '' && parseInt(value) !== 0) {
            count++;
          }
          break;
        case 'availability':
          filterMinimumAvailability(value, false);
          if (value !== '' && parseInt(value) !== 0) {
            count++;
          }
          break;
        case 'full':
          toggleFullActivities(value, false);
          break;
        case 'highschool_availability':
          toggleHighschoolAvailability(value, false);
          break;
      }
    })

    setSelectedFilterCount(count);

    api.setPage({ from: 0 });
    api.search();

    setFiltersVisible(false);
  }

  return (
    <div className={`SearchFilters ${filtersVisible ? '' : 'SearchFilters--hidden'}`}>
      <div>
        <button type="button" className="SearchFilters__toggle" onClick={toggleFilters}>
          <i className="icon icon-before icon-close" />
        </button>
        <FormikWrapper initialValues={initialValues}>
          <div className="SearchFilters__wrapper__left">
            <div className="SearchFilters__wrapper__left__selects">
              <FormSelect
                title="Soort activiteit"
                fieldName="type"
                placeholder="Kies een soort"
                options={{
                  23: 'Schoonmaken van de buurt',
                  24: 'Locatie opknappen',
                  25: 'Tuinieren',
                  28: 'Uitstapje maken',
                  35: 'Locatie schoonmaken / opruimen',
                  40: 'Natuuractiviteit',
                  43: 'Activiteit met doelgroep',
                }}
                onChange={filterType}
              />
              <FormSelect
                title="Wanneer"
                fieldName="date"
                placeholder="Kies een datum"
                options={{
                  1: 'Vrijdag',
                  2: 'Zaterdag',
                }}
                onChange={filterDate}
              />
            </div>
            <FormCheckbox
              title="Geschikt voor middelbare scholieren"
              fieldName="highschool_availability"
              onChange={toggleHighschoolAvailability}
            />
          </div>
          <div className="SearchFilters__wrapper__right">
            <FormSelect
              title="Plekken beschikbaar"
              fieldName="availability"
              placeholder="Kies aantal plekken"
              options={{
                1: '1 of meer',
                2: '2 of meer',
                5: '5 of meer',
                10: '10 of meer',
              }}
              onChange={filterMinimumAvailability}
            />
            <FormCheckbox
              title="Toon ook volle activiteiten"
              fieldName="full"
              onChange={toggleFullActivities}
            />
          </div>
          <div className={`MobileFooterButtons ${isMobile ? '' : 'hidden'}`}>
            <button
              type="button"
              className="Button"
              onClick={mobileFormSubmit}
            >
              Filters toepassen
            </button>
            <a href="/resultaten-op-naam" target="_parent" rel="noreferrer">of zoek op organisatienaam</a>
          </div>
        </FormikWrapper>
      </div>
      <button type="button" className="SearchFilters__toggle SearchFilters__toggle_open" onClick={toggleFilters}>
        <span>Filters ({selectedFilterCount})</span>
        <i className="icon icon-before icon-filter" />
      </button>
    </div>
  );
};

export default Filters;
